// src/components/ui/Card.tsx
import { motion } from 'framer-motion'
import { type ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  onClick?: () => void
}

export function Card({ children, className = '', onClick }: CardProps) {
  const Component = onClick ? motion.button : motion.div

  return (
    <Component
      whileTap={onClick ? { scale: 0.98 } : undefined}
      className={`
        bg-white rounded-3xl p-6 shadow-md
        ${onClick ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </Component>
  )
}
